export function onlyNumber(value: string | undefined): string {
  if (!value) return '';
  return value.replace(/\D/g, '');
}

export function isOnlyNumber(value: string | undefined): boolean {
  if (!value) return false;
  return /^\d+$/.test(value);
}
